import React, { useEffect } from 'react';
import { useCart } from '../contexts/CartContext';
import { Link, useLocation } from 'react-router-dom';

const CartPage = ({ isAuthenticated, setRedirectTo }) => {
  const { 
    cart, 
    cartTotal, 
    loading, 
    error, 
    updateCartItem, 
    removeFromCart,
    moveToCart
  } = useCart();

  const location = useLocation();
  useEffect(()=>{
      if (!isAuthenticated) {
          setRedirectTo(location.pathname);
      }
  },[isAuthenticated, location, setRedirectTo])

  const handleQuantityChange = async (cartId, newQuantity) => {
    if (newQuantity < 1) return;
    await updateCartItem(cartId, newQuantity);
  };

  if (loading && cart.length === 0) {
    return <div>Loading cart...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="cart-page">
      <h1>Your Shopping Cart</h1>
      
      {cart.length === 0 ? (
        <div className="empty-cart">
          <p>Your cart is empty</p>
          <Link to="/products" className="btn">Continue Shopping</Link>
        </div>
      ) : (
        <>
          <div className="cart-items">
            {cart.map(item => (
              <div key={item.id} className="cart-item">
                <div className="item-image">
                  <img 
                    src={item.product.image_url || '/images/default-product.jpg'} 
                    alt={item.product.name} 
                  />
                </div>
                <div className="item-details">
                  <h3>{item.product.name}</h3>
                  <p>${item.price.toFixed(2)}</p>
                  <div className="quantity-controls">
                    <button 
                      onClick={() => handleQuantityChange(item.id, item.quantity - 1)}
                      disabled={item.quantity <= 1}
                    >
                      -
                    </button>
                    <span>{item.quantity}</span>
                    <button 
                      onClick={() => handleQuantityChange(item.id, item.quantity + 1)}
                    >
                      +
                    </button>
                  </div>
                </div>
                <div className="item-actions">
                  <button 
                    onClick={() => removeFromCart(item.id)}
                    className="remove-btn"
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          <div className="cart-summary">
            <h3>Order Summary</h3>
            <div className="summary-row">
              <span>Subtotal</span>
              <span>${cartTotal.toFixed(2)}</span>
            </div>
            <div className="summary-row">
              <span>Shipping</span>
              <span>Free</span>
            </div>
            <div className="summary-row total">
              <span>Total</span>
              <span>${cartTotal.toFixed(2)}</span>
            </div>
            
            <button className="checkout-btn">Proceed to Checkout</button>
          </div>
        </>
      )}
    </div>
  );
};

export default CartPage;